import { render, staticRenderFns } from "./MediaKeyboardLink.vue?vue&type=template&id=52b97fd9&"
import script from "./MediaKeyboardLink.vue?vue&type=script&lang=js&"
export * from "./MediaKeyboardLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports